
























import { PropType, defineComponent } from '~/utils/nuxt3-migration'
import { TabVariant, TabMenu } from '~/models/app/tab'

export default defineComponent({
  props: {
    menu: {
      type: Array as PropType<TabMenu[]>,
      required: true
    },
    variant: {
      type: String as PropType<TabVariant>,
      default: 'secondary'
    }
  }
})
